import React from 'react';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import '@material-ui/core/Avatar';
import '@material-ui/core/Tooltip';
import '@material-ui/core/IconButton';
import '@material-ui/core/Badge';
import '@material-ui/core/Paper';
import '@material-ui/core/Divider';
import '@material-ui/icons/AccessTime';
import '@material-ui/icons/Check';
import '@material-ui/icons/Delete';
import 'classnames';
import '@material-ui/core/Card';
import '@material-ui/core/CardHeader';
import '../../../hooks/useConfig.esm.js';
import '../../../hooks/useCurrency.esm.js';
import '../../../hooks/useFilters.esm.js';
import '../../../hooks/useGroups.esm.js';
import '../../../hooks/useLoading.esm.js';
import '../../../hooks/useScroll.esm.js';
import '../../../hooks/useLastCompleteBillingDate.esm.js';
import '../../../utils/styles.esm.js';
import '../../../types/Alert.esm.js';
import { Duration } from '../../../types/Duration.esm.js';
import 'pluralize';
import '@material-ui/core/Grid';
import '@material-ui/core/Snackbar';
import '@material-ui/lab/Alert';
import '@material-ui/core/utils';
import '@material-ui/core/Button';
import '@material-ui/core/Dialog';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/Typography';
import '@material-ui/icons/Close';
import '../../../utils/alerts.esm.js';
import '@material-ui/core/Collapse';
import '@material-ui/icons/ExpandMore';
import '@material-ui/icons/MonetizationOn';
import '@material-ui/icons/Whatshot';
import '@material-ui/icons/Settings';
import '@material-ui/icons/AccountTree';
import '@material-ui/icons/Storage';
import '@material-ui/icons/Search';
import '@material-ui/icons/CloudQueue';
import '@material-ui/icons/School';
import '@material-ui/icons/ViewHeadline';
import '../../../utils/duration.esm.js';
import '../../../components/AlertInstructionsLayout/AlertInstructionsLayout.esm.js';
import 'recharts';
import '@material-ui/core/Slide';
import '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/ChevronRight';
import '../../../components/BarChart/BarChartStepperButton.esm.js';
import '@material-ui/core/ButtonBase';
import '@material-ui/icons/Lens';
import { monthOf } from '../../../utils/formatters.esm.js';
import { LegendItem } from '../../../components/LegendItem/LegendItem.esm.js';
import 'react-router-dom';
import 'react-use/esm/useCopyToClipboard';
import '@material-ui/icons/AssignmentOutlined';
import '@material-ui/icons/AssignmentTurnedInOutlined';
import '@material-ui/icons/SentimentVeryDissatisfied';
import { CostGrowth } from '../../../components/CostGrowth/CostGrowth.esm.js';
import '@material-ui/icons/ArrowDropUp';
import '@material-ui/icons/ArrowDropDown';
import 'luxon';
import 'react-use/esm/useAsync';
import '@backstage/core-plugin-api';
import '../../../components/CostInsightsLayout/CostInsightsLayout.esm.js';
import '../../../components/CostInsightsNavigation/CostInsightsNavigation.esm.js';
import '@material-ui/core/Container';
import '../../../api/CostInsightsApi.esm.js';
import '@material-ui/core/InputLabel';
import '@material-ui/core/Select';
import '@material-ui/core/FormControl';
import '@material-ui/core/MenuItem';
import '@material-ui/core/CardContent';
import '@material-ui/core/Tab';
import '@material-ui/core/Tabs';
import '@material-ui/core/styles/colorManipulator';
import '@material-ui/icons/Fullscreen';
import '@material-ui/core/CircularProgress';
import '@backstage/core-components';
import '@material-ui/core/Menu';
import '../../../components/ProjectGrowthInstructionsPage/ProjectGrowthInstructionsPage.esm.js';

const KubernetesMigrationBarChartLegend = ({
  currentProduct,
  comparedProduct,
  change,
  startDate
}) => {
  const theme = useTheme();
  return /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "row" }, /* @__PURE__ */ React.createElement(Box, { marginRight: 2 }, /* @__PURE__ */ React.createElement(
    LegendItem,
    {
      title: monthOf(startDate),
      markerColor: theme.palette.magenta
    },
    currentProduct
  )), /* @__PURE__ */ React.createElement(Box, { marginRight: 2 }, /* @__PURE__ */ React.createElement(LegendItem, { title: "Estimated Cost", markerColor: theme.palette.yellow }, comparedProduct)), /* @__PURE__ */ React.createElement(LegendItem, { title: "Total Savings" }, /* @__PURE__ */ React.createElement(CostGrowth, { change, duration: Duration.P30D })));
};

export { KubernetesMigrationBarChartLegend };
//# sourceMappingURL=KubernetesMigrationBarChartLegend.esm.js.map
